module.exports = __webpack_public_path__ + "img/tweetricon.5ecad2a7.svg";